import React from 'react';
import PropTypes from 'prop-types';
import { H2 } from 'components/atoms/Heading';
import { translate } from 'utils/translate';
import * as styles from './AwardList.scss';

const AwardList = ({ title, imageTitle, imageUrl, targetUrl }) => (
  <div className={styles.awardList}>
    <img src={imageUrl} alt={imageTitle} />
    <a href={targetUrl} target="_blank" rel="noopener">
      {title}
    </a>
  </div>
);
AwardList.displayName = 'AwardList';
AwardList.propTypes = {
  title: PropTypes.string.isRequired,
  imageTitle: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  awardName: PropTypes.string.isRequired,
  targetUrl: PropTypes.string.isRequired,
};

AwardList.defaultProps = {
  title: translate('/product/ecoCertyficate'),
};

export default AwardList;
